import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Axios instance met configuratie
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor om token toe te voegen
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor voor error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const _url = error.config?.url || '';
    const _isAuthFlow = _url.includes('/auth/login') || _url.includes('/auth/2fa/forced-setup');
    if (error.response?.status === 401 && !_isAuthFlow) {
      // Token is verlopen of ongeldig
      localStorage.removeItem('token');
      localStorage.removeItem('gebruiker');
      if (!window.location.pathname.startsWith('/login')) { window.location.href = '/login'; }
    }
    return Promise.reject(error);
  }
);

// Auth functies
export const authAPI = {
  login: (gebruikersnaam, wachtwoord) =>
    api.post('/auth/login', { gebruikersnaam, wachtwoord }),

  loginMfa: (mfa_token, code) =>
    api.post('/auth/login-mfa', { mfa_token, code }),

  register: (gebruikerData) =>
    api.post('/auth/register', gebruikerData),

  getCurrentUser: () =>
    api.get('/auth/me')
};

// 2FA / TOTP functies (MASVS L1)
export const twofaAPI = {
  status: () =>
    api.get('/auth/2fa/status'),
  setupStart: () =>
    api.post('/auth/2fa/setup-start'),
  setupVerify: (code) =>
    api.post('/auth/2fa/setup-verify', { code }),
  disable: (wachtwoord, code) =>
    api.post('/auth/2fa/disable', { wachtwoord, code }),
  regenerateRecovery: (code) =>
    api.post('/auth/2fa/regenerate-recovery', { code }),
  getBedrijfMfa: (bedrijfId) => api.get(`/auth/2fa/bedrijf/${bedrijfId}/required`),
  setBedrijfMfa: (bedrijfId, required) => api.put(`/auth/2fa/bedrijf/${bedrijfId}/required`, { required }),
  setBedrijfMfaRollen: (bedrijfId, rollen) => api.put(`/auth/2fa/bedrijf/${bedrijfId}/required-rollen`, { rollen }),
  getPortalMfa: (bedrijfId) => api.get(`/auth/2fa/bedrijf/${bedrijfId}/portal-mfa`),
  setPortalMfa: (bedrijfId, niveau) => api.put(`/auth/2fa/bedrijf/${bedrijfId}/portal-mfa`, { niveau })
};

// Gebruikers functies
export const gebruikersAPI = {
  getAll: () => 
    api.get('/gebruikers'),
  
  getById: (id) => 
    api.get(`/gebruikers/${id}`),
  
  update: (id, data) => 
    api.put(`/gebruikers/${id}`, data),
  
  delete: (id) => 
    api.delete(`/gebruikers/${id}`),
  
  getByRole: (rolnaam) => 
    api.get(`/gebruikers/rol/${rolnaam}`)
};

// Werkorders functies
export const werkordersAPI = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams(filters);
    return api.get(`/werkorders?${params}`);
  },
  
  getById: (id) => 
    api.get(`/werkorders/${id}`),
  
  create: (werkorderData) => 
    api.post('/werkorders', werkorderData),
  
  update: (id, data) => 
    api.put(`/werkorders/${id}`, data),
  
  delete: (id) => 
    api.delete(`/werkorders/${id}`)
};

export default api;
